var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn-guide",attrs:{"type":"button"},on:{"click":_vm.openGuide}})])}
var staticRenderFns = []

export { render, staticRenderFns }